import * as React from "react";
const SvgMicrosoft = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}><path d="M272 9.351h9.351V.623a.624.624 0 0 0-.623-.623H272z" data-name="Trazado 329" style={{
    fill: "#4caf50"
  }} transform="translate(-261.351)" /><path d="M9.351 9.351V0H.623A.624.624 0 0 0 0 .623v8.728z" data-name="Trazado 330" style={{
    fill: "#f44336"
  }} /><path d="M9.351 272H0v8.728a.624.624 0 0 0 .623.623h8.728z" data-name="Trazado 331" style={{
    fill: "#2196f3"
  }} transform="translate(0 -261.351)" /><path d="M272 272v9.351h8.728a.624.624 0 0 0 .623-.623V272z" data-name="Trazado 332" style={{
    fill: "#ffc107"
  }} transform="translate(-261.351 -261.351)" /></svg>;
export { SvgMicrosoft as ReactComponent };